<template>
  <div class="custom-select-v1" :class="{ error: hasError }">
    <span class="label">{{ label }}</span>
    <v-select
      :class="[
        customClass,
        !disabled ? 'select-chooser' : 'select-chooser-disabled',
      ]"
      :placeholder="placeholder"
      :label="selector"
      :value="contructedValue"
      :options="options"
      :clearable="false"
      :disabled="disabled"
      @input="onSelectChange" />
    <span v-if="hasError" class="error">{{ errorMessage }}</span>
  </div>
</template>

<script>
// Importing Vue and Vue Select
import Vue from "vue";
import vSelect from "vue-select";
// Importing the Vue Select Styles
import "vue-select/dist/vue-select.css";
// Registering the Vue Select Component
Vue.component("VSelect", vSelect);
export default {
  name: "CustomSelect",
  props: {
    title: { type: String, default: "" },
    value: { type: String, default: "" },
    label: { type: String, default: "" },
    errorMessage: { type: String, default: "" },
    customClass: { type: String, default: "" },
    selector: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    options: { type: Array, required: true },
    variant: {
      type: String,
      default: "",
    },
    type: { type: String, default: "large" },
    status: { type: String, default: "" },
    disabled: { type: Boolean, default: false },
    hasError: { type: Boolean, default: false },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  computed: {
    contructedValue() {
      return this.value ? { label: this.value, value: this.value } : null;
    },
  },
  methods: {
    onSelectChange(val) {
      this.$emit("onChange", { value: val.value, name: this.title });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/imports";
.custom-select-v1 {
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-bottom: 20px;
  position: relative;
  &.error {
    margin-bottom: 3px;
  }
  & .label {
    font-size: 16px;
    font-family: "Maersk Text";
    color: var(--Gray-800);
    margin-bottom: 5px;
    text-transform: none;
  }
  & .error {
    color: red;
    font-size: 12px;
  }
  & select {
    font-family: "Maersk Text";
    font-size: 14px;
    background: transparent;
    color: var(--primary-text);
    resize: none;
    border-radius: 4px;
    border: 1px solid var(--label-text);
    padding: 12px;
  }
  & .small {
    width: 101px;
  }
  & .medium {
    width: 360px;
    @include media("<=500px") {
      width: 280px;
    }
  }
}
.select-chooser,
.select-chooser-disabled {
  .vs__dropdown-toggle,
  .vs__dropdown-menu {
    overflow-y: auto;
    height: auto;
  }
  .vs__search,
  .vs__search:focus {
    color: var(--primary-text);
  }
  .vs__dropdown-toggle {
    border: 1px solid var(--Gray-400);
    height: 42px !important;
  }
  .vs__dropdown-option {
    white-space: normal;
    padding: 10px 5px;
  }
  .vs__selected-options {
    display: contents;
  }
  .vs__clear,
  .vs__open-indicator {
    position: absolute;
    right: 8px;
    display: block;
    z-index: 10;
    // fill: var(--primary-text);
    &:hover {
      cursor: pointer;
    }
  }
}
.select-chooser {
  .vs__selected {
    white-space: normal;
    color: var(--primary-text);
  }
}
.select-chooser-disabled {
  .vs__selected {
    white-space: normal;
    color: black;
  }
}
</style>
